import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ActivityPanelComponent } from './activity-panel.component';

@NgModule({
  declarations: [
    ActivityPanelComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
  ],
  exports: [
    ActivityPanelComponent,
  ],
})
export class ActivityPanelModule {}
